import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/login/Login.vue'
import Template from '../views/root/Template.vue'
import Dashboard from '../views/Dashboard.vue'

const DownloadApp = () => import('../views/downloadApp/Index.vue')
const GroupList = () => import('/src/views/group/GroupList.vue')
const GroupDetail = () => import('/src/views/group/GroupDetail.vue')
const GroupApply = () => import('/src/views/group/GroupApply.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { static: true },
    },
    {
      path: '/',
      component: Template,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: '/group/list',
          component: GroupList,
          meta: {
            title: '我的班级'
          },
        },
        {
          path: '/group/detail',
          component: GroupDetail,
          meta: {
            title: '班级详情'
          },
        },
        {
          path: '/group/apply',
          component: GroupApply,
          meta: {
            title: '关联班级'
          },
        },
      ],
    },
    {
      path: '/download-app',
      component: DownloadApp,
      meta: {
        static: true,
        title: '外研AI学习版',
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})
